module.exports = "<span #container placement=\"top\" [ngbTooltip]=\"isEllipsised && text\" class=\"tooltips\" triggers=\"hover click blur\">\n    {{text || \"(vide)\"}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/requete/historique-requete/timeline/tooltips/tooltips.component.html
// module id = 828
// module chunks = 0